import React from 'react';
import { Link } from 'react-router-dom';
import BackBar from '../components/BackBar'; // adjust depth to wherever this file lands
import './LastPaper.css';

/*
 * The Last Piece of Paper — replaces the old EnvironmentalImpact page.
 * Same typographic system as Manifesto.jsx: villain → belief → declaration.
 *
 * ⚠️ COPY VERIFICATION before ship:
 *  - "in your name" on the tree card: confirm One Tree Planted attribution
 *    actually works that way. If not, the card copy below (which omits it)
 *    is already safe — only add "in your name" once confirmed.
 *  - Stats sourced to Green America "Skip the Slip" and the Ecology Center
 *    receipt study. Keep the source line; it's what makes righteous bulletproof.
 */

export default function LastPaper() {
  return (
    <div className="lastpaper-page">
      <BackBar />

      <article className="lastpaper">
        <header className="lp-header">
          <h1 className="lp-title">The Last Piece of Paper</h1>
          <p className="lp-kicker">Why the receipt doesn&rsquo;t deserve to exist.</p>
        </header>

        <p className="lp-body">
          Every day, the most advanced payment system in history prints its
          proof on paper. Coated in chemicals. Handed to you in three seconds.
          Faded in three months.
        </p>

        <p className="lp-body">
          It&rsquo;s the only thing a store gives you that was obsolete before
          it finished printing.
        </p>

        <p className="lp-strike">It looks like paper. It isn&rsquo;t.</p>

        <p className="lp-body">
          Most receipts are thermal paper, coated in BPA or BPS &mdash; the
          same chemicals banned from baby bottles. The Ecology Center found
          them in 93% of receipts tested. And because of that coating,
          receipts can&rsquo;t be recycled. Toss one in the paper bin and it
          contaminates the paper that can be.
        </p>

        <div className="lp-stats" role="group" aria-label="Annual U.S. receipt impact">
          <p className="lp-stats-intro">
            In the United States alone, paper receipts consume every year:
          </p>
          <div className="lp-stats-row">
            <div className="lp-stat">
              <span className="lp-stat-number">10M</span>
              <span className="lp-stat-label">trees</span>
            </div>
            <div className="lp-stat">
              <span className="lp-stat-number">1B</span>
              <span className="lp-stat-label">gallons of water</span>
            </div>
            <div className="lp-stat">
              <span className="lp-stat-number">1.5B</span>
              <span className="lp-stat-label">pounds of waste</span>
            </div>
          </div>
          <p className="lp-stats-source">
            Source: Green America, &ldquo;Skip the Slip&rdquo;
          </p>
        </div>

        <p className="lp-body">
          Here&rsquo;s the part nobody says out loud: you never wanted the
          paper. You wanted the proof. The refund. The warranty. The record
          of where your money went.
        </p>

        <p className="lp-body">
          The paper was never the point. The proof was.
        </p>

        <p className="lp-strike">
          KACHNG keeps the proof and kills the paper.
        </p>

        <div className="lp-tree-card">
          <h2 className="lp-tree-title">A tree for every milestone</h2>
          <p className="lp-tree-body">
            Hit a receipt milestone in KACHNG and we plant a tree with{' '}
            <a
              className="lp-tree-link"
              href="https://onetreeplanted.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              One&nbsp;Tree&nbsp;Planted
            </a>
            . Your habit stops waste on one end and puts a tree in the ground
            on the other.
          </p>
        </div>

        <footer className="lp-close">
          <p className="lp-close-line">Kill your last receipt.</p>
          <Link to="/" className="lp-cta">
            Get KACHNG
          </Link>
        </footer>
      </article>
    </div>
  );
}